import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { territorio } from '../../shared/object/territorio.model';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { vendedor } from '../../shared/object/vendedor.model';
import { SecurityService } from '../../shared/services/security.service';
import { ValidadoresService } from '../../shared/validadores/validadores';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { RubroService } from 'src/app/services/rubro.service';
import { UsuariosVendedorComponent } from './usuarios-vendedor/usuarios-vendedor/usuarios-vendedor.component';
import { RutService } from '../../shared/services/rut.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { UsuarioService } from 'src/app/services/usuario.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
@Component({
  selector: 'app-vendedor',
  templateUrl: './vendedor.component.html',
  styleUrls: ['./vendedor.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class VendedorComponent implements OnInit {
  private client: GraphQLClient = null;
  public busquedaEstado= 1;
  public rutEmpresa;
  public sucursalCodigo;
  filtroNombre: string = ""; 

  public formAgregarVendedor: FormGroup;
  public formEditarVendedor: FormGroup;
  nombreCompleto: string = "";
  territorioList: territorio[];
  vendedorList: Array<any> = null;
  vendedores: vendedor;
  selectedVend: vendedor;
  optionsTerritorio: Array<any> = [];
  optionsRubro: Array<any> = [];
  @ViewChild('centralLarge', { static: true }) agregarModal: ModalDirective;
  @ViewChild('centralLargex', { static: true }) editarModal: ModalDirective;
  @ViewChild(UsuariosVendedorComponent, { static: true }) modalAgregarUsuario: UsuariosVendedorComponent

  public codgo_modulo:number = 5;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());


  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    private rubroService: RubroService,
    private rutService: RutService,
    private toastService: ToastService,
    private usuarioService: UsuarioService,
    private messageRendererService: MessageRendererService
  ) {
    this.client = client;
    this.formAgregarVendedor = this.construyeFormAgrega();
    this.formEditarVendedor = this.construyeFormEdita();
  }

  ngOnInit() {
    this.selectedVend = {
      codigo: null,
      rut_empresa: null,
      sucursal_codigo: null,
      nombre: '',
      territorio_codigo: null,
      fono1: '',
      fono2: '',
      estado: false,
      comision: 0,
      rut: null,
      listaRubro: null
    };

    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();
    this.loadRubros()
    this.obtenerDatosTerritorio(this.rutEmpresa, this.sucursalCodigo);
    this.obtenerDatosVendedores(this.rutEmpresa, this.sucursalCodigo);
  }

  obtenerDatosTerritorio(rutEmpresa: number, sucursalcodigo: number) {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query(
            $rut_empresa: Decimal
            $sucursal_codigo: Decimal
            $tipobusqueda: Int
          ) {
            territorio {
              obtenerSegunFiltro(
                filtro: {
                  exacto: {
                    empresa_rut: $rut_empresa
                    sucursal_codigo: $sucursal_codigo
                    tipobusqueda: $tipobusqueda
                  }
                }
              ) {
                respuesta {
                  registros {
                    codigo
                    nombre
                    descripcion
                    empresa_rut
                    sucursal_codigo
                    estado
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rut_empresa: rutEmpresa,
          sucursal_codigo: sucursalcodigo,
          tipobusqueda: 1,
        },
      },
      function (respuesta) {
        self.territorioList =
          respuesta.data.territorio.obtenerSegunFiltro.respuesta.registros;
        self.optionsTerritorio = [];
        let sel: any;
        self.territorioList.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsTerritorio.push(sel);
        });
      }
    );
  }

  /***************Construccion de formularios reactivos****************/
  construyeFormAgrega() {
    return new FormGroup({
      codigo: new FormControl(0, [Validators.required, Validators.min(0)]),
      nombre: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(200),
      ]),
      fono1: new FormControl(
        { value: '' },
        Validators.compose([Validators.minLength(9), Validators.maxLength(15)])
      ),
      fono2: new FormControl({ value: '' },
      Validators.compose([Validators.minLength(9), Validators.maxLength(15)])
      ),
      estado: new FormControl(true),
      territorio: new FormControl(0, [Validators.required]),
      rut: new FormControl('', [
        Validators.minLength(7),
        Validators.maxLength(13),
        Validators.required,
        this.validadores.ValidaFormatoRut,
      ]),
      listaRubro: new FormControl(''),
    });

  }

  loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsRubro = registros.map(rubro => ({
        value: rubro.codigo,
        label: rubro.descripcion
      }))
    })
  }
  construyeFormEdita() {
    return new FormGroup({
      codigo: new FormControl({ value: 0, disabled: true }, [
        Validators.required,
        Validators.min(0),
      ]),
      empresa_rut: new FormControl(''),
      sucursal_codigo: new FormControl(''),
      nombre: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(200),
      ]),
      fono1: new FormControl({ value: '' }, Validators.compose([
        Validators.maxLength(15),
        Validators.minLength(8),
      ])),
      fono2: new FormControl({ value: '' }, Validators.compose([
        Validators.maxLength(15),
        Validators.minLength(8),
      ])),
      estado: new FormControl(true),
      territorio: new FormControl(0, [Validators.required]),
      rut: new FormControl({ value: '', disabled: false }, [
        Validators.minLength(7),
        Validators.maxLength(13),
        Validators.required,
        this.validadores.ValidaFormatoRut,
      ]),
      listaRubro: new FormControl(''),
    });
  }

  get frmAgregaCodigo() {
    return this.formAgregarVendedor.get('codigo');
  }
  get frmAgregaNombre() {
    return this.formAgregarVendedor.get('nombre');
  }
  get frmAgregaComision() {
    return this.formAgregarVendedor.get('comision');
  }
  get frmAgregaFono1() {
    return this.formAgregarVendedor.get('fono1');
  }
  get frmAgregaFono2() {
    return this.formAgregarVendedor.get('fono2');
  }
  get frmAgregaEstado() {
    return this.formAgregarVendedor.get('estado');
  }
  get frmAgregaTerritorio() {
    return this.formAgregarVendedor.get('territorio');
  }
  get frmAgregaRut() {
    return this.formAgregarVendedor.get('rut');
  }
  get frmAgregarRubro() {
    return this.formAgregarVendedor.get('listaRubro');
  }

  get frmEditarCodigo() {
    return this.formEditarVendedor.get('codigo');
  }
  get frmEditarRut_Empresa() {
    return this.formEditarVendedor.get('rut_empresa');
  }
  get frmEditarSucursal_Codigo() {
    return this.formEditarVendedor.get('sucursal_codigo');
  }
  get frmEditarNombre() {
    return this.formEditarVendedor.get('nombre');
  }
  get frmEditarComision() {
    return this.formEditarVendedor.get('comision');
  }
  get frmEditarEstado() {
    return this.formEditarVendedor.get('estado');
  }
  get frmEditarFono1() {
    return this.formEditarVendedor.get('fono1');
  }
  get frmEditarFono2() {
    return this.formEditarVendedor.get('fono2');
  }
  get frmEditarTerritorio() {
    return this.formEditarVendedor.get('territorio');
  }
  get frmEditarRut() {
    return this.formEditarVendedor.get('rut');
  }
  get frmEditarRubro() {
    return this.formEditarVendedor.get('listaRubro');
  }

  /***************Fin de Construccion de formularios reactivos****************/

  filtraxEstado() {
    this.obtenerDatosVendedores(
      Number(this.rutEmpresa),
      Number(this.sucursalCodigo)
    );
  }

  muestraModalAgrega() {
    this.selectedVend = {
      rut_empresa: null,
      sucursal_codigo: null,
      codigo: null,
      nombre: '',
      comision: null,
      estado: true,
      fono1: '',
      fono2: '',
      rut: null,
      territorio_codigo: null,
      listaRubro:null
    };
    this.formAgregarVendedor.reset();
  }

  mascaraRut(evento) {
    const rut = this.validadores._mascaraRut(evento);

    if(rut){
      // Verificar que existe usuario en usuario
      this.obtenerUsuario(rut);
    }
  }

  obtenerUsuario(rut){
    const rutFormato = this.rutService.QuitarDV(
      this.rutService.Limpiar(rut.toString()));

      const inputParams = {
        entidad:{
          rut_usuario: rutFormato,
          login: '',
          password: '',
          fecha_creacion: new Date(),
          fecha_modificacion: new Date(),
          mail: '',
          activo: true,
          nombre_completo: null,
          flag_cambioclave: true
        },
        rut_empresa: this.rutEmpresa,
        roles_codigo: [],
        sucursal_codigo: []
      };

      this.usuarioService.obtenerUsuariosxEmpresa(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }
        const {registros} = respuesta;
        //completar informacion de usuario
        this.nombreCompleto = registros[0].nombre_completo
      });
  }

  insertar() {
    this.selectedVend.rut = Number(
      this.validadores._desenmascaraRutyQuitaDV(this.frmAgregaRut.value)
    );
    this.selectedVend.rut_empresa = this.rutEmpresa;
    this.selectedVend.sucursal_codigo = this.sucursalCodigo;
    this.selectedVend.territorio_codigo = this.frmAgregaTerritorio.value;
    this.selectedVend.nombre = this.frmAgregaNombre.value;
    this.selectedVend.codigo = this.frmAgregaCodigo.value;
    this.selectedVend.comision = 0;
    this.selectedVend.estado = this.frmAgregaEstado.value;
    this.selectedVend.fono1 = this.frmAgregaFono1.value;
    this.selectedVend.fono2 = this.frmAgregaFono2.value;
    this.selectedVend.listaRubro = this.frmAgregarRubro.value
    this.postVendedores(this.selectedVend);
  }

  AbrirModalAgregarUsuario(){
    this.agregarModal.hide();
    const nombre_vendedor = this.formAgregarVendedor.get('nombre').value;
    const rut_vendedor = this.formAgregarVendedor.get('rut').value;
    this.modalAgregarUsuario.load(nombre_vendedor, rut_vendedor);
  }

  UserSaveComplete(){
    this.ValidaQueExisteDatosVendedor();
    this.agregarModal.hide();
  }

  VendedorSave(){
    this.ValidaQueExisteDatosVendedor();
    this.agregarModal.hide();
  }

  ValidaQueExisteDatosVendedor() {
    const self = this; // this is unused
    const datavendedor: vendedor = new vendedor();

    datavendedor.codigo = this.frmAgregaCodigo.value;
    datavendedor.rut = Number(
      this.validadores._desenmascaraRutyQuitaDV(this.frmAgregaRut.value)
    );
    datavendedor.rut_empresa = Number(this.rutEmpresa);
    datavendedor.sucursal_codigo = Number(this.sucursalCodigo);

    this.client.query(
      {
        query: gql`
          query($entidad: vendedorInputType) {
            vendedor {
              existe(entidad: $entidad) {
                respuesta
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          entidad: datavendedor,
        },
      },
      function (respuesta) {
        if (respuesta.data.vendedor.existe.respuesta) {
          const res = window.confirm(
            'El código de vendedor ingresado ya existe. ¿Desea sobreescribirlo?'
          );
          if (res) {
            self.insertar();
          }
        } else {
          self.insertar();
        }
      }
    );
  }

  postVendedores(nuevoVendedor: vendedor) {
    const self = this;
    const bodyx = nuevoVendedor;
    delete bodyx['__typename'];
    delete bodyx['rutFormato'];

    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: vendedorInputType) {
            vendedor {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  nombre
                  estado
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.vendedor.guardar.respuesta == null) {
          if (respuesta.data.vendedor.guardar.mensajes.length > 0) {
            alert(respuesta.data.vendedor.guardar.mensajes[0].texto);
          }

        }else{
          self.toastService.success("Se ha agregado el vendedor satisfactoriamente.");
        }

        setTimeout(
          () =>
            self.obtenerDatosVendedores(self.rutEmpresa, self.sucursalCodigo),
          1000
        );
      }
    );
  }

  cambiaEstado(vendSeleccionado: vendedor) {
    if (vendSeleccionado.estado) {
      vendSeleccionado.estado = false;
    } else {
      vendSeleccionado.estado = true;
    }
    this.postVendedores(vendSeleccionado);
  }

  obtenerDatosVendedores(rutEmpresa, sucursalCodigo) {
    let self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query(
            $rut_empresa: Decimal
            $sucursal_codigo: Decimal
            $tipobusqueda: Int
            $nombre: String
          ) {
            vendedor {
              obtenerSegunFiltro(
                filtro: {
                  exacto: {
                    rut_empresa: $rut_empresa
                    sucursal_codigo: $sucursal_codigo
                    tipobusqueda: $tipobusqueda
                    nombre: $nombre
                  }
                }
              ) {
                respuesta {
                  registros {
                    codigo
                    rut_empresa
                    sucursal_codigo
                    nombre
                    fono1
                    fono2
                    estado
                    territorio_codigo
                    rut
                    territorioNombre
                    comision
                    listaRubro
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rut_empresa: rutEmpresa,
          sucursal_codigo: sucursalCodigo,
          tipobusqueda: this.busquedaEstado,
          nombre: this.filtroNombre,
        },
      },
      function (response) {
        const { registros } =  response.data.vendedor.obtenerSegunFiltro.respuesta;

        self.vendedorList = registros;

        self.vendedorList.forEach((vend, index) => {
          vend.rutFormato = {}
          vend.rutFormato = self.rutService.AgregarDV(vend.rut);
        })


      }
    );


  }

  showForEdit(vend: vendedor) {
    this.selectedVend = Object.assign({}, vend);
    this.formEditarVendedor.reset();
    this.frmEditarCodigo.setValue(this.selectedVend.codigo);
    this.frmEditarNombre.setValue(this.selectedVend.nombre);
    this.frmEditarFono1.setValue(this.selectedVend.fono1);
    this.frmEditarFono2.setValue(this.selectedVend.fono2);
    this.frmEditarEstado.setValue(this.selectedVend.estado);
    this.frmEditarTerritorio.setValue(this.selectedVend.territorio_codigo);
    this.frmEditarRut.setValue(
      this.validadores._enmascaraRut(String(this.selectedVend.rut))
    );
    this.formEditarVendedor.get('listaRubro').setValue(vend.listaRubro);
  }

  actualizar() {
    this.selectedVend = {
      nombre: this.frmEditarNombre.value,
      codigo: this.frmEditarCodigo.value,
      comision: 0,
      estado: this.frmEditarEstado.value,
      fono1: this.frmEditarFono1.value,
      fono2: this.frmEditarFono2.value,
      rut: Number(
        this.validadores._desenmascaraRutyQuitaDV(this.frmEditarRut.value)
      ),
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
      territorio_codigo: this.frmEditarTerritorio.value,
      listaRubro:this.frmEditarRubro.value,
    };

    this.postVendedores(this.selectedVend);
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
        self.formAgregarVendedor.get('estado').setValue(true);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }

  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(vendSeleccionado: vendedor) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(vendSeleccionado);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
